import { EStatusBackgroundColors } from '../enums/status-background-colors.enum';
import { XpassStatusLabels } from '../enums/xpass-status-labels.enum';
import { ColorMapping } from '../interfaces/color-mapping.interface';

export const SCHEDULED_DATE_PROPERTY = 'ScheduledDate';
export const LAST_UPDATED_PROPERTY = 'LastUpdatedDate';
export const DATE_FORMAT = 'MM/DD/YY hh:mm';
export const ONLY_DATE_FORMAT = 'MM/DD/YY';
export const ONLY_TIME_FORMAT = 'hh:mm:ss A';

export const STATUSES_WITH_BLACK_TEXT = [
  XpassStatusLabels.CONFIRMED,
  XpassStatusLabels.BOAT,
];

export const STATUS_PILL_COLOR_MAPPING: ColorMapping = {
  Confirmed: EStatusBackgroundColors.YELLOW_COLOR_HEX,
  Tricycle: EStatusBackgroundColors.ORANGE_COLOR_HEX,
  Boat: EStatusBackgroundColors.BLUE_COLOR_HEX,
  'E-trike': EStatusBackgroundColors.GREEN_COLOR_HEX,
  Completed: EStatusBackgroundColors.LIGHT_BLUE_COLOR_HEX,
  Cancelled: EStatusBackgroundColors.RED_COLOR_HEX,
};
